import { PlusOutlined } from '@ant-design/icons';
import {
    Button,
    Col,
    Empty,
    Image,
    Input,
    Modal,
    notification,
    Row,
    Space,
    Table,
    Tag,
    Tooltip
} from "antd";
import { useEffect, useState } from "react";
import { getAllApps, getAllIosApps } from "../../../axios/api.app";
import {
    addAndroidTemplateApp,
    addTemplateApp,
    deleteAndroidTemplateAllApp,
    deleteAndroidTemplateApp,
    deleteTemplateAllApp,
    deleteTemplateApp,
    getAndroidTemplateApp,
    getTemplateApp
} from "../../../axios/api.device";
import { stringContaint } from "../../../utils/common";
import { gaEvent } from "../../../withTracker";

import i18n from "@src/locales";
import { useTranslation } from "react-i18next";

const { Column } = Table
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentApp = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [tableList, setTableList] = useState<any[]>([]);
    const [appList, setApplist] = useState<any[]>([]);
    const [appSearchList, setAppSearchlist] = useState<any[]>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectPackages, setSelectPackages] = useState<any[]>();
    const [selectKeys, setSelectKeys] = useState<any[]>();

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    var deleteAllClick = () => {
        localStorage.removeItem('selectPackages');
        if (platform == "Android") {
            deleteAndroidTemplateAllApp(templateId).then(c => {
                updateTemplate();
                notification.success({ message: t("删除成功") });
                getList();
                setShowTable(1)
            })
        } else {
            deleteTemplateAllApp(templateId).then(c => {
                updateTemplate();
                notification.success({ message: t("删除成功") });
                getList();
                setShowTable(1)
            })
        }

    }
    const onSearch = (value: string) => {
        var arr = appList?.filter(c => {
            return stringContaint(value.toLowerCase(), c.name.toLowerCase());
        });
        if (appSearchList.length) {
            setAppSearchlist([]);
        }
        setTimeout(() => {
            setAppSearchlist([...arr]);
        }, 100);
    }

    function getList() {
        var localDataString = localStorage.getItem('selectPackages');
        var localData = localDataString ? JSON.parse(localDataString) : [];
        
        if (platform == "Android") {
            getAndroidTemplateApp(templateId).then(c => {
                if (c && c.length > 0) {
                    setTableList([...c, ...localData])
                    setShowTable(2)
                    getAppLIst([...c, ...localData]);
                } else {
                    getAppLIst([...c, ...localData]);
                    setTableList(localData);
                    if (localData.length > 0) {
                        setShowTable(2);
                    } else {
                        setShowTable(1);
                    }
                }
            })
        } else {
            getTemplateApp(templateId).then(c => {
                if (c && c.length > 0) {
                    setTableList([...c, ...localData]);
                    setShowTable(2);
                    getAppLIst([...c, ...localData]);
                } else {
                    getAppLIst([...c, ...localData]);
                    setTableList(localData);
                    if (localData.length > 0) {
                        setShowTable(2);
                    } else {
                        setShowTable(1);
                    }
                }
            })
        }

    }
    function getAppLIst(tbList: any[]) {
        if (platform == "Android") {
            getAllApps({ platform: 'Android' }).then(res => {
                if (res) {
                    var arr = res.filter((all: any) => {
                        var index = tbList.findIndex(ins => {
                            return ins.appId == all.appId
                        })
                        return index == -1;
                    })
                    var androidList: any[] = [];
                    arr.forEach((ele: any) => {
                        androidList.push({
                            adamId: ele.appId,
                            version: ele.versionNumber,
                            iconUrl: ele.logoUrl,
                            name: ele.name,
                            packageName: ele.packageName
                        })
                    });
                    setApplist(androidList);
                    setAppSearchlist(androidList);
                }
            })
        } else {
            if (platform === "macOS") {
                getAllIosApps({ deviceType: "PC"}).then(res => {
                    if (res) {
                        var arr = res.filter(all => {
                            var index = tbList.findIndex(ins => {
                                return ins.appId == all.adamId
                            })
                            return index == -1;
                        })
                        arr.forEach(element => {
                            element.packageName = element.bundleId
                        });
                        setApplist([...arr]);
                        setAppSearchlist([...arr]);
                    
                    }
                })
            } else {
                getAllIosApps({ deviceType: "Phone", pageIndex: 1, pageSize: 9999 }).then(res => {
                    if (res) {
                        var arr =res;
                        arr = arr.filter(all => {
                            var index = tbList.findIndex(ins => {
                                return ins.appId == all.adamId
                            })
                            return index == -1;
                        })
                        arr.forEach(element => {
                            element.packageName = element.bundleId
                        });
                        setApplist([...arr]);
                        setAppSearchlist([...arr]);
                        
                    }
                })
            }
        }

    }
    useEffect(() => {
        getList();
        return () => { localStorage.removeItem('selectPackages') }
    }, [])
    const onChange = (selectedRowKeys: any[], selectedRows: any[]) => {
        setSelectKeys(selectedRowKeys)
        setSelectPackages(selectedRows);
    }
    const rowSelection = {
        selectedRowKeys: selectKeys,
        onChange: onChange
    };
    const modalClick = (datas:any = []) => {
        if (datas.length === 0) {
            datas = selectPackages;
        }
        setLoading(true);
        if (!datas || datas?.length == 0) {
            notification.error({ message: t("未添加新应用") });
            setSelectKeys([]);
            setLoading(false);
            updateTemplate();
            return;
        }
        var args: any[] = [];

        if (platform == "Android") {
            datas?.forEach(((c: any) => {
                args.push(c.adamId)
            }))
            addAndroidTemplateApp(templateId, { appIds: args }).then(res => {
                localStorage.removeItem('selectPackages');
                setLoading(false);
                setShowModal(false);
                updateTemplate();
                setSelectPackages([]);
                setSelectKeys([])
                getList();
                notification.success({message: t("保存成功")});
            }, () => {
                setLoading(false);
                notification.error({message: t("保存失败")});
            })
        } else {
            datas?.forEach(((c: any) => {
                args.push({
                    appId: c.adamId,
                    appName: c.name,
                    packageName: c.packageName,
                    version: c.version,
                    enterpriseAppId: c.enterpriseAppId,
                    isEnterprise: c.isEnterprise
                })
            }))
            addTemplateApp(templateId, args).then(res => {
                localStorage.removeItem('selectPackages');
                setLoading(false);
                setShowModal(false);
                updateTemplate();
                setSelectPackages([]);
                setSelectKeys([])
                getList();
                notification.success({message: t("保存成功")});
            }, () => {
                setLoading(false);
                notification.error({message: t("保存失败")});
            })
        }


    }
    const deleteClick = (id: string) => {
        var localDataString = localStorage.getItem('selectPackages');
        var localData = localDataString ? JSON.parse(localDataString) : [];
        if (localData.length > 0) {
            var filterData = localData.filter((data: any) => { return data.appId !== id });
            if (filterData.length !== localData.length) {
                localStorage.setItem('selectPackages', JSON.stringify(filterData));
                notification.success({ message: t("移除成功") });
                getList();
                return
            }
        }
        if (platform == "Android") {
            deleteAndroidTemplateApp(templateId, id).then(() => {
                updateTemplate();
                notification.success({ message: t("删除成功") });
                getList();

            })
        } else {
            deleteTemplateApp(templateId, id).then(() => {
                updateTemplate()
                notification.success({ message: t("删除成功") });
                getList();

            })
        }
    }
    const columns = [
        {
            title: '图标',
            dataIndex: 'iconUrl',
            filterMultiple: false,
            key: "iconUrl",
            render: (iconUrl: any) => <Image width={50} height={50} src={iconUrl}></Image>
        },
        {
            title: '应用名称',
            dataIndex: 'name',
            filterMultiple: false,
            key: 'name',
        },
        {
            title: '包名',
            dataIndex: 'packageName',
            key: 'packageName',
        },
        // {
        //     title: '版本',
        //     dataIndex: 'version',
        //     key: 'version',
        // },
    ];

    const save = () => {
        var localDataString = localStorage.getItem('selectPackages');
        var localData = localDataString ? JSON.parse(localDataString) : [];
        modalClick(localData);
    }
    const addApp = () => {
        if (selectPackages?.length == 0) {
            notification.error({ message: t("未选择应用") });
            setSelectKeys([])
            return;
        } else {
            var args: any[] = [];
            selectPackages?.forEach((c => {
                args.push({
                    appId: c.adamId,
                    appName: c.name,
                    packageName: c.packageName,
                    version: c.version,
                    adamId: c.adamId,
                    name: c.name,
                    enterpriseAppId: c.enterpriseAppId,
                    isEnterprise: c.isEnterprise
                })
            }))
            var localDataString = localStorage.getItem('selectPackages');
            var localData = localDataString ? JSON.parse(localDataString) : [];
            if (localData.length > 0) {
                args.push(...localData);
            }
            localStorage.setItem('selectPackages', JSON.stringify(args));
            setLoading(false);
            setShowModal(false);
            setSelectPackages([]);
            setSelectKeys([])
            getList();
        }
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle"> {t("应用")}</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities?.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>{t("使用此配置文件需添加的应用")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick() }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <div className="tAr">
                            <Button type="primary" onClick={() => { setShowModal(true); gaEvent("templateContentApp", "onClick", "setShowModal") }}><PlusOutlined />{t("添加应用")}</Button>
                        </div>
                        <Table 
                            dataSource={tableList} 
                            rowKey={record => record.appId} 
                            style={{ width: "100%" ,marginLeft:8}}
                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                        >
                            <Column
                                title={t("名称")}
                                key="appName"
                                dataIndex="appName"
                            ></Column>
                            <Column title={t("包名")} key="packageName" dataIndex="packageName"></Column>

                            {/* <Column
                                title={t("版本")}
                                key="version"
                                dataIndex="version"
                            ></Column> */}

                            <Column
                                title={t("操作")}
                                key="appId"
                                dataIndex="appId"
                                render={(v) => {
                                    return (
                                        <a style={{ color: "#007ACC" }} onClick={() => { deleteClick(v) }}>{t("移除")}</a>
                                    )
                                }}></Column>
                        </Table>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" loading={loading} onClick={() => save()}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteAllClick(); gaEvent("templateContentApp", "onClick", "deleteAllClick") }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
            <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={showModal}
                title={t("添加应用")}
                width={"1000px"}
                onOk={() => addApp()}
                onCancel={() => setShowModal(false)}
                okText={t("确认")}
                cancelText={t("取消")}
                destroyOnClose
            >
                <Space direction="vertical" style={{ width: "100%" }}>
                    <Row>
                        <Col span={4}>{t("应用名称")}:</Col>
                        <Col span={18}>
                            <Input.Search 
                                placeholder={t("输入查询名称")} 
                                allowClear 
                                enterButton={t("搜索")}
                                onSearch={onSearch} 
                            />
                        </Col>
                    </Row>
                    <Row >
                        <Table 
                            scroll={{ y: '240px' }} 
                            pagination={false} 
                            columns={columns.map((item)=>{
                                item.title = t(item.title)
                                return item 
                            })} 
                            style={{ width: "100%" }} 
                            dataSource={appSearchList} 
                            rowSelection={rowSelection} 
                            rowKey={record => record.packageName} 
                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                        />
                    </Row>
                </Space>
            </Modal>
        </div>
    </>);
};